import Store from 'repatch';

import State from '../core/State';
import {
  setAvailablePoint,
  setBudgets,
  setChildPointTransactions,
  setChildPointTransactionsLoading,
  setPointTransactions,
} from '../reducer/bf';
import { setCurrentBfOrganization, setCurrentBfOrganizationLoading } from '../reducer/organization';
import ApiErrorHandler from '../service/ApiErrorHandler';
import MessageDispatcher from '../service/MessageDispatcher';
import BfWebApi from '../service/persistent/BfWebApi';

class BfUsecase {
  private store: Store<State>;
  // @ts-ignore TS6133:
  private apiErrorHandler: ApiErrorHandler;
  private bfWebApi: BfWebApi;
  // @ts-ignore TS6133:
  private messageDispatcher: MessageDispatcher;

  constructor({
    store,
    apiErrorHandler,
    bfWebApi,
    messageDispatcher,
  }: {
    store: Store<State>;
    apiErrorHandler: ApiErrorHandler;
    bfWebApi: BfWebApi;
    messageDispatcher: MessageDispatcher;
  }) {
    this.store = store;
    this.apiErrorHandler = apiErrorHandler;
    this.bfWebApi = bfWebApi;
    this.messageDispatcher = messageDispatcher;
  }

  public getOrganization = async (id: string): Promise<void> => {
    this.store.dispatch(setCurrentBfOrganizationLoading(true));
    const organization = await this.bfWebApi.getOrganization(id);
    this.store.dispatch(setCurrentBfOrganization(organization));
    this.store.dispatch(setCurrentBfOrganizationLoading(false));
  };

  public getBudget = async (kaizenUserId: string): Promise<void> => {
    const budget = await this.bfWebApi.getBudget(kaizenUserId);
    this.store.dispatch(setAvailablePoint(budget.availablePoint));
    this.store.dispatch(setBudgets(budget.budgets));
  };

  public getPointTransactions = async (kaizenUserId: string): Promise<void> => {
    try {
      const pointTransactionHistory = await this.bfWebApi.getPointTransactions(kaizenUserId);
      this.store.dispatch(setPointTransactions(pointTransactionHistory));
    } catch (_e) {
      const e: any = _e;
      // 権限がないときにページが開かれてしまった場合
      if (!(e && e.response && e.response.status === 403)) {
        throw e;
      }
    }
  };

  public getChildPointTransactions = async (childId: string): Promise<void> => {
    try {
      this.store.dispatch(setChildPointTransactionsLoading(true));
      const pointTransactionHistory = await this.bfWebApi.getPointTransactions(childId);
      this.store.dispatch(setChildPointTransactions(childId, pointTransactionHistory));
    } catch (_e) {
      const e: any = _e;
      // 小組織に所属がないケースは403がくる
      if (!(e && e.response && e.response.status === 403)) {
        throw e;
      }
    } finally {
      this.store.dispatch(setChildPointTransactionsLoading(false));
    }
  };
}

export default BfUsecase;
